import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Search, ArrowRight } from 'lucide-react';

const SearchScreen = ({ onSubmit, animeName, setAnimeName }) => {
  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (animeName.trim()) {
      onSubmit();
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="bg-white rounded-2xl shadow-xl p-8"
    >
      <h2 className="text-2xl font-bold text-center mb-8 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
        Which anime series shall we investigate?
      </h2>
      <form onSubmit={handleSubmit} ref={formRef}>
        <div className="relative">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-purple-100 focus:border-purple-500 focus:ring focus:ring-purple-200 transition-all duration-200 outline-none"
            placeholder="Enter anime name..."
            value={animeName}
            onChange={(e) => setAnimeName(e.target.value)}
          />
        </div>
        <motion.button
          type="submit"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="w-full mt-6 bg-gradient-to-r from-purple-600 to-blue-600 text-white py-3 rounded-xl flex items-center justify-center space-x-2 hover:from-purple-700 hover:to-blue-700 transition-all duration-200"
        >
          <span>Start Investigation</span>
          <ArrowRight className="w-5 h-5" />
        </motion.button>
      </form>
    </motion.div>
  );
};

export default SearchScreen;